import { render, staticRenderFns } from "./ScrapButton.vue?vue&type=template&id=c82b0208&"
import script from "./ScrapButton.vue?vue&type=script&lang=js&"
export * from "./ScrapButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports